import { render, staticRenderFns } from "./supplierGeneralPriceList.vue?vue&type=template&id=5720c1a3&"
import script from "./supplierGeneralPriceList.vue?vue&type=script&lang=js&"
export * from "./supplierGeneralPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports